import { useQuery } from "@tanstack/react-query";
import classNames from "classnames";
import { useState } from "react";
import { Badge, Table } from "react-bootstrap";
import Laoding from "../../components/Loading";
import PaginateCard from "../../components/PaginateCard";
import PrintLink from "../../components/Shipment/Factor/PrintLink";
import { getRequestByAuth } from "../../function/helper";
import dateTimeToJalali from "../../function/jalali/dateTimetoJalali";
import useFilters from "../../hooks/useFilters";
import PreOrderCodeFilters from "./PreOrderCodeFilters";
import PreOrderCodePrint from "./PreOrderCodePrint";
import PreOrderCodeSelectAllButton from "./PreOrderCodeSelectAllButton";
import PreOrderCodeTableCheckbox from "./PreOrderCodeTableCheckbox";

export default function PreOrderCodeList() {
  const filters = useFilters({ page: 1, items: 10 });
  const [selected, setSelected] = useState([]);

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["PreOrderCodeList"],
    queryFn: () =>
      getRequestByAuth(
        "/totalpost/v1/preOrderCode/list",
        filters.getAll()
      ).then(res => {
        if (res && res.status === 200) {
          return res.data;
        }

        return { items: [], count: 0 };
      }),

    placeholderData: { items: [], count: 0 },
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return (
    <div className="pt-4 pb-5">
      <PreOrderCodeFilters
        filters={filters}
        isFetching={isFetching}
        refetch={() => {
          filters.set("page", 1);
          refetch();
          setSelected([]);
        }}
      />

      <p className="pt-4 fs-5 text-success">
        <strong>تعداد: </strong>
        <strong>{data.count.toLocaleString()}</strong>
      </p>

      <div className="w-100 overflow-x-auto">
        <Table striped bordered>
          <thead>
            <tr className="align-middle">
              <th className="text-center">ردیف</th>
              <th className="text-center">کد</th>
              <th className="text-center">شماره سفارش</th>
              <th className="text-center">وضعیت</th>
              <th className="text-center">تاریخ</th>
              <th className="text-center" style={{ width: 130 }}>
                <PreOrderCodeSelectAllButton
                  items={data.items}
                  selected={selected}
                  setSelected={setSelected}
                />
              </th>
            </tr>
          </thead>

          <tbody>
            {isFetching && (
              <tr>
                <td colSpan="100">
                  <Laoding />
                </td>
              </tr>
            )}

            {!isFetching &&
              data.items.map((item, idx) => (
                <tr key={item.id} className="align-middle">
                  <td className="text-center">
                    {idx + 1 + (filters.get("page") - 1) * filters.get("items")}
                  </td>
                  <td
                    className="text-center"
                    style={{ letterSpacing: "0.2rem" }}
                  >
                    {item.code}
                  </td>
                  <td className="text-center">
                    {item.total_post?.numberParcel && (
                      <PrintLink
                        ids={[item.total_post?.numberParcel]}
                        byNumberParcel
                      >
                        {item.total_post?.numberParcel}
                      </PrintLink>
                    )}
                  </td>
                  <td className="text-center">
                    <Badge
                      className={classNames(
                        item.total_post ? "bg-primary" : "bg-orange"
                      )}
                    >
                      {item.total_post ? "متصل" : "قابل استفاده"}
                    </Badge>
                  </td>

                  <td className="text-center">
                    {dateTimeToJalali(item.created_at).full}
                  </td>

                  <td>
                    <PreOrderCodeTableCheckbox
                      item={item}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>

      <PaginateCard
        count={data.count}
        numberItems={filters.get("items")}
        numberPage={filters.get("page")}
        onIndexChoose={page => {
          filters.set("page", page);
          refetch();
          setSelected([]);
        }}
      />

      <PreOrderCodePrint selected={selected} />
    </div>
  );
}
